import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

type User = {
  name?: string;
  email?: string;
};

type UserInfo = {
  userName: string;
  userEmail: string | undefined;
};

export function getUserInfo(user: User | undefined): UserInfo {
  const userName = user?.name || user?.email?.split("@")[0] || "User";
  const userEmail = user?.email;

  return {
    userName,
    userEmail,
  };
}
